// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  subdistrict_id: number
  subdistrict_name: string
}

export function useSubdistrictById(): {
  data: Type | null
  isLoading: boolean
  fetchData: (subdistrict_id: number | string) => void
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchData = (subdistrict_id: number | string) => {
    setLoading(true)

    api.get(
      "/subdistricts/byid",
      { params: { subdistrict_id } }
    ).then((res: SuccessFetch<{
      payload: Type
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, fetchData }
}